import { Component, Input } from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-recap-escorteds',
  styleUrls: ['./recap-escorteds.component.scss'],
  templateUrl: './recap-escorteds.component.html'
})
export class RecapEscortedsComponent {
  @Input() public day: any;
  @Input() public serviceIcons: any;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }
}
